module.exports = __webpack_public_path__ + "static/media/horario.b304ed9e.svg";